import { callAPI } from "../../network/networkConnection";
import { NetworkConfiguration } from "../../network/networkConfriguation";

const base = process.env.REACT_APP_APIUrl;

// Get all affiliates (users where isAffiliate is true)
const getAffiliates = (params = {}) => {
  const q = new URLSearchParams(params).toString();
  const url = q ? `${base}${NetworkConfiguration.ADMIN_GET_AFFILIATES}?${q}` : base + NetworkConfiguration.ADMIN_GET_AFFILIATES;
  return callAPI(url, "GET", { "Content-Type": "application/json" }, null);
};

// Get affiliate by ID
const getAffiliateById = (id) =>
  callAPI(`${base}${NetworkConfiguration.ADMIN_GET_AFFILIATES}/${id}`, "GET", { "Content-Type": "application/json" }, null);

// Update affiliate
const updateAffiliate = (id, payload) =>
  callAPI(`${base}${NetworkConfiguration.ADMIN_GET_AFFILIATES}/${id}`, "PUT", { "Content-Type": "application/json" }, JSON.stringify(payload));

// Delete affiliate
const deleteAffiliate = (id) =>
  callAPI(`${base}${NetworkConfiguration.ADMIN_GET_AFFILIATES}/${id}`, "DELETE", { "Content-Type": "application/json" }, null);

// Update affiliate status
const updateAffiliateStatus = (id, status) =>
  callAPI(`${base}${NetworkConfiguration.ADMIN_GET_AFFILIATES}/${id}/status`, "PATCH", { "Content-Type": "application/json" }, JSON.stringify({ status }));

// Get commission plans for dropdown
const getCommissionPlansForDropdown = () =>
  callAPI(`${base}admin/commission-plans-dropdown`, "GET", { "Content-Type": "application/json" }, null);

// Get commission plans
const getCommissionPlans = (params = {}) => {
  const q = new URLSearchParams(params).toString();
  const url = q ? `${base}${NetworkConfiguration.ADMIN_GET_COMMISSION_PLANS}?${q}` : base + NetworkConfiguration.ADMIN_GET_COMMISSION_PLANS;
  return callAPI(url, "GET", { "Content-Type": "application/json" }, null);
};

// Get commission plan by ID
const getCommissionPlanById = (id) =>
  callAPI(`${base}${NetworkConfiguration.ADMIN_GET_COMMISSION_PLANS}/${id}`, "GET", { "Content-Type": "application/json" }, null);

// Create commission plan
const createCommissionPlan = (payload) =>
  callAPI(base + NetworkConfiguration.ADMIN_GET_COMMISSION_PLANS, "POST", { "Content-Type": "application/json" }, JSON.stringify(payload));

// Update commission plan
const updateCommissionPlan = (id, payload) =>
  callAPI(`${base}${NetworkConfiguration.ADMIN_GET_COMMISSION_PLANS}/${id}`, "PUT", { "Content-Type": "application/json" }, JSON.stringify(payload));

// Delete commission plan
const deleteCommissionPlan = (id) =>
  callAPI(`${base}${NetworkConfiguration.ADMIN_GET_COMMISSION_PLANS}/${id}`, "DELETE", { "Content-Type": "application/json" }, null);

// Update commission plan status
const updateCommissionPlanStatus = (id, status) =>
  callAPI(`${base}${NetworkConfiguration.ADMIN_GET_COMMISSION_PLANS}/${id}/status`, "PATCH", { "Content-Type": "application/json" }, JSON.stringify({ status }));

// Get payout settings
const getPayoutSettings = () =>
  callAPI(base + NetworkConfiguration.ADMIN_GET_PAYOUT_SETTINGS, "GET", { "Content-Type": "application/json" }, null);

// Update payout settings
const updatePayoutSettings = (payload) =>
  callAPI(base + NetworkConfiguration.ADMIN_UPDATE_PAYOUT_SETTINGS, "PUT", { "Content-Type": "application/json" }, JSON.stringify(payload));

// Get withdrawal requests
const getWithdrawalRequests = (params = {}) => {
  const q = new URLSearchParams(params).toString();
  const url = q ? `${base}${NetworkConfiguration.ADMIN_GET_WITHDRAWAL_REQUESTS}?${q}` : base + NetworkConfiguration.ADMIN_GET_WITHDRAWAL_REQUESTS;
  return callAPI(url, "GET", { "Content-Type": "application/json" }, null);
};

// Approve withdrawal request
const approveWithdrawal = (id) =>
  callAPI(`${base}admin/withdrawal-requests/${id}/approve`, "POST", { "Content-Type": "application/json" }, null);

// Reject withdrawal request
const rejectWithdrawal = (id, reason) =>
  callAPI(`${base}admin/withdrawal-requests/${id}/reject`, "POST", { "Content-Type": "application/json" }, JSON.stringify({ reason }));

// Get fraud alerts
const getFraudAlerts = (params = {}) => {
  const q = new URLSearchParams(params).toString();
  const url = q ? `${base}${NetworkConfiguration.ADMIN_GET_FRAUD_ALERTS}?${q}` : base + NetworkConfiguration.ADMIN_GET_FRAUD_ALERTS;
  return callAPI(url, "GET", { "Content-Type": "application/json" }, null);
};

// Block user for fraud
const blockFraudUser = (userId, reason) =>
  callAPI(`${base}${NetworkConfiguration.ADMIN_BLOCK_FRAUD_USER}/${userId}`, "POST", { "Content-Type": "application/json" }, JSON.stringify({ reason }));

// Get affiliate dashboard stats
const getAffiliateDashboard = () =>
  callAPI(base + NetworkConfiguration.ADMIN_GET_AFFILIATE_DASHBOARD, "GET", { "Content-Type": "application/json" }, null);

// Get affiliate program settings (eligibility, bonus - controls seller portal)
const getAffiliateProgramSettings = () =>
  callAPI(base + NetworkConfiguration.ADMIN_GET_AFFILIATE_PROGRAM_SETTINGS, "GET", { "Content-Type": "application/json" }, null);

// Update affiliate program settings
const updateAffiliateProgramSettings = (payload) =>
  callAPI(base + NetworkConfiguration.ADMIN_UPDATE_AFFILIATE_PROGRAM_SETTINGS, "PUT", { "Content-Type": "application/json" }, JSON.stringify(payload));

export const AdminAffiliateApiService = {
  getAffiliates,
  getAffiliateById,
  updateAffiliate,
  deleteAffiliate,
  updateAffiliateStatus,
  getCommissionPlansForDropdown,
  getCommissionPlans,
  getCommissionPlanById,
  createCommissionPlan,
  updateCommissionPlan,
  deleteCommissionPlan,
  updateCommissionPlanStatus,
  getPayoutSettings,
  updatePayoutSettings,
  getWithdrawalRequests,
  approveWithdrawal,
  rejectWithdrawal,
  getFraudAlerts,
  blockFraudUser,
  getAffiliateDashboard,
  getAffiliateProgramSettings,
  updateAffiliateProgramSettings,
};
